module.exports = __webpack_public_path__ + "static/media/c-male.fc1e3ed4.webp";